import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Utils } from './Utils';
import helpers from "@/helpers/helper";
import moment from 'moment';

@Component
export default class BaseVue extends Vue {
    constructor() {
        super();
        this.$validator.localize('es');
    }
    get user(){
        return this.$store.state.user;
    }
    public yearSelected = 0;
    public get yearRange() {
        return [-100, 1000];
    }
    get isMobile() {
        return this.$store.state.isMobile;
    }
    get meses() {
        return helpers.MonthNames;
    }
    get dias() {
        return helpers.DayNames;
    }
    getValueDate(value: string) {
        return moment(value).format("L");
    }
    getFormatDate(fecha: any) {
        return `DateTime.Parse("${moment(fecha).format()}")`;
    }

    getDateTimeOffsetFormatDate(fecha: any) {
        return `DateTimeOffset.Parse("${moment(fecha).format()}")`;
    }
    formatDate(date: Date) {
        var mm = date.getMonth() + 1;
        var dd = date.getDate();
        var yyyy = date.getFullYear();
        var format = dd + '/' + mm + '/' + yyyy;
        return format;
    }
    operationSuccess(message: string = "Operación exitosa!", duration = 2000) {
        this.$buefy.toast.open({
            message: message,
            type: 'is-success',
            duration: duration
        });
    }

    operationFailed(message: string = "Operación fallída!", duration = 4000) {
        this.$buefy.toast.open({
            message: message,
            type: 'is-danger',
            position: "is-top-right",
            duration: duration
        });
    }
    operationNoAllowed(message: string = "Operación no permitida!", duration = 4000) {
        this.$buefy.toast.open({
            message: message,
            type: 'is-warning',
            duration: duration,
            position: "is-bottom",
        });
    }

    operationFailedErrors(errors: string[] | string | any, queue = false, duration = 4000, type = "is-danger") {
        const items = Array.isArray(errors) ? errors : [errors];
        items
        .map(e => {
            if (typeof e === "string")
                return e;

            if (e && e.message)
                return e.message;

            if (e && e.errorMessage)
                return e.errorMessage;

            return "Operación fallida!";
        })
        .forEach(e => this.$buefy.toast.open({
            message: e,
            duration: duration,
            queue: queue,
            type: type,
            position: "is-top-right"
        }))
    }

    protected async validateCurrentValidator() {
        try {
            if (!this.$validator || typeof this.$validator.validateAll !== "function")
                return true;

            const isValid = await this.$validator.validateAll();
            if (isValid)
                return true;

            throw this.$validator.errors.items.map(e => e.msg);
        } catch (errors) {
            this.operationFailedErrors(errors);
            return false;
        }
    }

    public async isValid() {
        return this.validateCurrentValidator();
    }

    protected getRefCollection(refName: string) {
        const refs = (this.$refs as any)[refName];
        if (!refs)
            return [];

        return Array.isArray(refs) ? refs : [refs];
    }

    protected async validateRefCollection(refName: string) {
        let isValid = true;
        for (const ref of this.getRefCollection(refName)) {
            if (typeof ref.isValid !== "function")
                continue;

            const refValid = await ref.isValid();
            if (!refValid)
                isValid = false;
        }

        return isValid;
    }

    copy(obj: any) {
        return JSON.parse(JSON.stringify(obj));
    }

    map<T>(from: any) {
        return Utils.mapSimpleObject<T>(from, {});
    }

    equals(from: any, to: any): boolean {
        var result = false;
        for (let key in from) {
            if (to.hasOwnProperty(key)) {
                if (to[key] === from[key])
                    result = true;
                else {
                    result = false;
                    break;
                }
            } else
                result = false;
        }

        return result;
    }
}
